module.exports = __webpack_public_path__ + "static/js/dataToCsv.8dae4aeb.chunk.worker.js"